import { nanoid } from 'nanoid';
const TAB_SESSION_KEY = 'TAB_SESSION_ID';
export const getTabId = (() => {
    var _a;
    const tabWindow = window;
    let tabId = (_a = tabWindow[TAB_SESSION_KEY]) !== null && _a !== void 0 ? _a : sessionStorage.getItem(TAB_SESSION_KEY);
    // Keep sessionStorage empty during normal tab lifetime so duplicated tabs
    // do not inherit the active tab id.
    sessionStorage.removeItem(TAB_SESSION_KEY);
    if (!tabId) {
        tabId = `${Date.now()}-${nanoid()}`;
    }
    tabWindow[TAB_SESSION_KEY] = tabId;
    const persistTabId = () => {
        sessionStorage.setItem(TAB_SESSION_KEY, tabWindow[TAB_SESSION_KEY]);
    };
    window.addEventListener('pagehide', persistTabId);
    window.addEventListener('beforeunload', persistTabId);
    return () => tabWindow[TAB_SESSION_KEY];
})();
